/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdjustmentReasonAdminDto } from '../models/AdjustmentReasonAdminDto';
import type { PostAdjustmentReasonAdminRequest } from '../models/PostAdjustmentReasonAdminRequest';
import type { PutAdjustmentReasonAdminRequest } from '../models/PutAdjustmentReasonAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdjustmentReasonsService {
    /**
     * **Required Policy:** `ViewAdjustmentReasons`
     * @returns AdjustmentReasonAdminDto OK
     * @throws ApiError
     */
    public static getAdjustmentReasonsAdmin(): CancelablePromise<Array<AdjustmentReasonAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/adjustmentreasons',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageAdjustmentReasons`
     * @returns AdjustmentReasonAdminDto OK
     * @throws ApiError
     */
    public static createAdjustmentReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostAdjustmentReasonAdminRequest,
    }): CancelablePromise<AdjustmentReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/adjustmentreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageAdjustmentReasons`
     * @returns AdjustmentReasonAdminDto OK
     * @throws ApiError
     */
    public static updateAdjustmentReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutAdjustmentReasonAdminRequest,
    }): CancelablePromise<AdjustmentReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/adjustmentreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageAdjustmentReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAdjustmentReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/adjustmentreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
